import React, {Fragment} from 'react';
import styled from 'styled-components';
import BeneficiaryColumn from './BeneficiaryColumn';
import BeneficiaryColumnSm from './BeneficiaryColumnSm';
import {beneficiarySummary} from '../../data/beneficiaries.js';

const ColumnWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
	margin-top: 3em;

	@media screen and (min-width: 640px) {
		margin-top: 6em;
	}
`;

const BeneficiaryGroup = ({children, isSmall}) => {
	return (
		<Fragment>
			<ColumnWrapper>
				{beneficiarySummary.slice(0,3).map((el, index) => (
					<BeneficiaryColumn
						key={index}
						category={el.category}
						total={el.total}
						desc={el.description}
						image={el.image}
					/>
				))}
			</ColumnWrapper>

			{children}

			<ColumnWrapper style={{marginTop: '0', marginBottom: '8em'}}>
				{beneficiarySummary.slice(3).map((el, index) => (
					<BeneficiaryColumnSm
						key={index}
						category={el.category}
						total={el.total}
						desc={el.description}
						isSmall={isSmall}
					/>
				))}
			</ColumnWrapper>
		</Fragment>
	);
};

export default BeneficiaryGroup;
